import './video-text.scss';

class VideoText {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-videotext',
            playButtonValue: 'play',
        };

        // Merge settings
        this.settings = Object.assign({}, defaults, options);

        // DOM Elements
        this.$root = element;
        this.$playButton = this.$root.querySelector(`[${this.settings.initAttr}="${this.settings.playButtonValue}"]`);

        // Options
        this.cookieId = 'C0003';
    }

    initialize () {
        if (this.$playButton) {
            import('../../utilities/js/youtube-player').then(({ YoutubePlayer }) => {
                this.initYoutubePlayer(YoutubePlayer);
            });
        }
    }

    setActiveState (active) {
        this.$root.setAttribute(this.settings.activeAttr, active);
    }

    initYoutubePlayer (YoutubePlayer) {
        const videoPlayer = new YoutubePlayer(this.$playButton, {
            eventScroller: window.eventScroller,
            autoplay: true,
            width: 1600,
            height: 900,
            onCall: () => {
                this.$root.classList.add('show--video');
            },
            onEnd: () => {
                if (videoPlayer.player.video.isMuted() === false || videoPlayer.mute === 0) {
                    videoPlayer.destroy();
                }
            }
        });
    }
}

export { VideoText };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-videotext="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new VideoText($root);
            $rootAPI.initialize();
        });
    }
});
